/* ==========================================================================
   nb-collection.js
   マットレスカテゴリページのタブ切替のみを担当する。
   絞り込み・並べ替えは Shopify 標準のフィルタURL／テーマ既存JSに任せているため、
   ここでは通信を一切行わない。

   注意：Prestige は絞り込み時にセクションHTMLを差し替える（AJAX）ため、
   要素に直接addEventListenerすると差し替え後に効かなくなる。
   そのため document へのイベント委譲にしている。
   ========================================================================== */
(function () {
   'use strict';

   var TAB_ATTR = 'data-nb-tab';        // ヘッダー側（.nb-cat）
   var SECTION_ATTR = 'data-nb-cat-tab'; // セクション全体（商品カードのバッジ出し分け用）

   function switchTab(button) {
      var next = button.getAttribute('data-nb-tabbtn');
      if (!next) return;

      var head = button.closest('.nb-cat');
      if (head) head.setAttribute(TAB_ATTR, next);

      // バッジは .nb-cat の外（商品グリッド内）にあるので、セクション側にも反映する
      var section = button.closest('[data-section-type="collection"]');
      if (section) section.setAttribute(SECTION_ATTR, next);

      // タブのaria状態を更新
      if (head) {
         var tabs = head.querySelectorAll('[data-nb-tabbtn]');
         for (var i = 0; i < tabs.length; i++) {
            var isCurrent = tabs[i].getAttribute('data-nb-tabbtn') === next;
            tabs[i].setAttribute('aria-selected', isCurrent ? 'true' : 'false');
         }
      }
   }

   document.addEventListener('click', function (event) {
      var button = event.target.closest ? event.target.closest('[data-nb-tabbtn]') : null;
      if (!button) return;
      event.preventDefault();
      switchTab(button);
   });

   // キーボード操作（左右キーでタブ移動）
   document.addEventListener('keydown', function (event) {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      var current = document.activeElement;
      if (!current || !current.hasAttribute || !current.hasAttribute('data-nb-tabbtn')) return;

      var head = current.closest('.nb-cat');
      if (!head) return;
      var tabs = Array.prototype.slice.call(head.querySelectorAll('[data-nb-tabbtn]'));
      var index = tabs.indexOf(current);
      if (index === -1) return;

      var nextIndex = event.key === 'ArrowRight' ? index + 1 : index - 1;
      if (nextIndex < 0) nextIndex = tabs.length - 1;
      if (nextIndex >= tabs.length) nextIndex = 0;

      event.preventDefault();
      tabs[nextIndex].focus();
      switchTab(tabs[nextIndex]);
   });

   /* ------------------------------------------------------------------
      プレビュー用パラメータの引き継ぎ

      絞り込みボタンのリンクは /collections/mattress?sort_by=...&filter... で、
      プレビュー用の view / preview_theme_id を含んでいない。
      そのため ?view=mattress でプレビューしていると、ボタンを押した瞬間に
      パラメータが落ちて標準のカテゴリページに戻ってしまう。

      本番ではコレクションにテンプレート接尾辞を割り当てるため
      これらのパラメータは不要になり、この処理は何もしない（空振りする）。
      あくまでプレビューで正しく確認できるようにするための補助。
      ------------------------------------------------------------------ */
   /* preview_theme_id はあえて引き継がない。
      これが付いたURLを開くとShopifyがプレビュー用Cookieを設定して転送し直すが、
      その転送で同名パラメータ（複数選択した絞り込み条件）が1つに潰されてしまう。
      プレビューCookieは最初の表示で設定済みなので、以降のリンクには不要。 */
   var PREVIEW_KEYS = ['view', '_ab', '_fd', '_sc'];

   function carryPreviewParams() {
      try {
         if (!window.URL || !window.URLSearchParams) return;

         var current = new URLSearchParams(window.location.search);
         var carry = [];
         for (var i = 0; i < PREVIEW_KEYS.length; i++) {
            if (current.has(PREVIEW_KEYS[i])) {
               carry.push([PREVIEW_KEYS[i], current.get(PREVIEW_KEYS[i])]);
            }
         }
         if (carry.length === 0) return; // 本番はここで終了

         var links = document.querySelectorAll('a.nb-cat-btn[href], a.nb-cat-reset[href]');
         for (var j = 0; j < links.length; j++) {
            var url = new URL(links[j].getAttribute('href'), window.location.origin);
            for (var k = 0; k < carry.length; k++) {
               if (!url.searchParams.has(carry[k][0])) {
                  url.searchParams.set(carry[k][0], carry[k][1]);
               }
            }
            links[j].setAttribute('href', url.pathname + url.search);
         }
      } catch (e) {
         /* 失敗してもリンク自体は生きているので何もしない */
      }
   }

   /* ------------------------------------------------------------------
      並べ替えボタンの表示名を、選んだ項目に追従させる

      Prestige の並べ替えは AJAX で商品一覧（.CollectionInner__Products）だけを
      差し替え、ツールバーの並べ替えボタンは差し替えない。
      そのため「価格の低い順」を選んでもボタンは「おすすめ順」のまま残っていた
      （2026-09-10 先方FB③⑦）。選択された項目の文言をボタンへ反映する。
      ------------------------------------------------------------------ */
   document.addEventListener('click', function (event) {
      var option = event.target.closest ? event.target.closest('#collection-sort-popover [data-action="select-value"]') : null;
      if (!option) return;

      var text = (option.textContent || '').replace(/\s+/g, ' ').trim();
      if (!text) return;

      var labels = document.querySelectorAll('.nb-cat-sortlabel');
      for (var i = 0; i < labels.length; i++) {
         labels[i].textContent = text;
      }

      // ポップオーバー内の選択状態も合わせる（テーマ側で更新されない場合の保険）
      var options = document.querySelectorAll('#collection-sort-popover [data-action="select-value"]');
      for (var j = 0; j < options.length; j++) {
         options[j].classList.toggle('is-selected', options[j] === option);
      }
   });

   /* ------------------------------------------------------------------
      リセットボタンの出し分け（2026-09-18 先方FB）

      「更に絞り込む」ドロワーでの絞り込みはAJAXで、テーマは商品一覧と
      絞り込みボタンの中身だけを差し替える（_reloadProducts）。
      リセットボタンはその外にあるため、サーバー描画のままだと状態が古くなる。
      絞り込みボタンに出ている件数を見て、付け外しする。

      なお「かたさ」「シリーズ」のボタンはページ遷移なので、
      条件のテキスト表示はサーバー側の描画で常に正しくなる。
      ------------------------------------------------------------------ */
   function syncResetVisibility() {
      var bar = document.querySelector('.nb-cat-filterbar');
      if (!bar) return;
      var button = bar.querySelector('.CollectionToolbar__Item--filter');
      if (!button) return;

      var matched = (button.textContent || '').match(/\((\d+)\)/);
      var count = matched ? parseInt(matched[1], 10) : 0;
      if (count > 0) {
         bar.classList.add('is-filtered');
      } else {
         bar.classList.remove('is-filtered');
      }
   }

   function watchFilterCount() {
      if (!window.MutationObserver) return;
      var bar = document.querySelector('.nb-cat-filterbar');
      if (!bar) return;
      var button = bar.querySelector('.CollectionToolbar__Item--filter');
      if (!button || button.getAttribute('data-nb-watched') === '1') return;

      // テーマは className と innerHTML を差し替えるが、data属性は残るので重複監視を防げる
      button.setAttribute('data-nb-watched', '1');
      new MutationObserver(syncResetVisibility).observe(button, {
         childList: true,
         subtree: true,
         characterData: true
      });
   }

   // 初期表示時にaria-selectedを合わせる
   function initAria() {
      var heads = document.querySelectorAll('.nb-cat');
      for (var i = 0; i < heads.length; i++) {
         var currentTab = heads[i].getAttribute(TAB_ATTR);
         var tabs = heads[i].querySelectorAll('[data-nb-tabbtn]');
         for (var j = 0; j < tabs.length; j++) {
            tabs[j].setAttribute('aria-selected', tabs[j].getAttribute('data-nb-tabbtn') === currentTab ? 'true' : 'false');
         }
      }
   }

   function init() {
      initAria();
      carryPreviewParams();
      syncResetVisibility();
      watchFilterCount();
   }

   if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
   } else {
      init();
   }

   // AJAXでセクションが差し替わったあとも属性・リンクを合わせ直す
   document.addEventListener('shopify:section:load', init);
})();
